import { render, staticRenderFns } from "./ajout-stock.html?vue&type=template&id=094fcfa6&scoped=true&external"
import script from "./ajout-stock.js?vue&type=script&lang=js&external"
export * from "./ajout-stock.js?vue&type=script&lang=js&external"
import style0 from "./ajout-stock.scss?vue&type=style&index=0&id=094fcfa6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094fcfa6",
  null
  
)

export default component.exports